import { dataHooks } from '@wix/data-hooks';

export const chatWidgetDataHooks = dataHooks<{
  assistantMessage: { index: number };
  userChatMessage: { index: number };
  tags: {};
}>('app');
